import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HashtagRegular from './hashtag-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HashtagRegular {...validProps} />;
}

SvgComponent.iconName = 'hashtagRegular';

export const HashtagRegularIcon = svgIconWrapper(SvgComponent);
